import { AfterViewInit, Directive, ElementRef, Input, OnChanges, OnDestroy } from '@angular/core';
import { Subscription } from 'rxjs';
import { CommonMethods } from '../common-methods';
import { UiService } from '../ui.service';

@Directive({
	selector: '[appIngressHandler]'
})
export class IngressHandlerDirective implements OnChanges, AfterViewInit, OnDestroy {

	@Input() handleIngress: string | undefined;
	@Input() elementDisplay: string | null | undefined;
	currentRole: string | null | undefined;
	roleSubscription: Subscription | undefined;

	constructor(
		private el: ElementRef,
		private _uiService: UiService
	) { }

	/**
	 * Set current role.
	 * @param role 
	 * 
	 * @returns void
	 */
	setCurrentRole(role: string | null = null): void {
		this.currentRole = role;
	}

	/**
	 * Get current role.
	 * 
	 * @returns string | null
	 */
	getCurrentRole(): string | null | undefined {
		return this.currentRole;
	}

	/**
	 * Make role null if it is undefined.
	 * 
	 * @returns string | null
	 */
	sanitizeRole(role: string | null | undefined): string | null {
		if (role === undefined) {
			role = null;
		}
		return role;
	}

	/**
	 * Fetch current role from local storage.
	 * 
	 * @returns void
	 */
	fetchLocalRole(): void {
		let localRole: string | null | undefined = CommonMethods.getItem('role');
		localRole = this.sanitizeRole(localRole);
		this.setCurrentRole(localRole);
	}

	/**
	 * Update current role if role changed.
	 * 
	 * @returns void
	 */
	updateOnRoleChanged(): void {
		this.roleSubscription = this._uiService.currentRole.subscribe((role: string | null | undefined) => {
			role = this.sanitizeRole(role);
			this.setCurrentRole(role);
			this.handle();
		});
	}

	/**
	 * Get the HTMLElement where the directive is added,
	 * then check from CommonMethods if there is any 
	 * restriction for current role,
	 * and show / hide them accordingly.
	 * 
	 * @returns void
	 */
	handle(): void {
		const htmlElement = this.el.nativeElement as HTMLElement;
		if (this.elementDisplay === undefined || this.elementDisplay === null) {
			htmlElement.setAttribute('style', 'display:block !important');
		} else {
			htmlElement.setAttribute('style', 'display:' + this.elementDisplay + ' !important');
		}
		let ingressFilteredArray = CommonMethods.ingressSettings.filter((x: any) => x.role == this.getCurrentRole());
		if (ingressFilteredArray.length > 0) {
			let permissions = ingressFilteredArray[0].permission;
			if (this.handleIngress && !permissions.includes(this.handleIngress)) {
				htmlElement.setAttribute('style', 'display:none !important');
			}
		} else {
			htmlElement.setAttribute('style', 'display:none !important');
		}
	}

	ngOnChanges(): void {
		this.fetchLocalRole();
		this.updateOnRoleChanged();
	}

	ngAfterViewInit(): void {
		this.handle();
	}

	ngOnDestroy(): void {
		if (this.roleSubscription) {
			this.roleSubscription.unsubscribe();
		}
	}
}
